import styled from "styled-components";
import { theme } from "../../styles/theme";

export const StyledUnitContainer = styled.div`
	max-height: ${(props) => (props.collapsed ? "7.4rem" : "min-content")};
	overflow: hidden;
	border-radius: 0.4rem;
	background-color: ${theme.color.blue0};
	transition: max-height 1s;

	& > div:not(.container) {
		margin-bottom: ${(props) => (props.collapsed ? "0" : ".5rem")};
	}

	& div.inactive {
		margin-bottom: 0.5rem;
	}

	& > div:not(:first-child) {
		margin-left: 3.3rem;
	}
`;

export const StyledUnitCard = styled.div`
	padding: ${(props) => (!props.type === "link" ? "0.6rem 4.5rem 0.6rem 0.6rem" : "1rem 4.5rem 1rem 1rem")};

	display: flex;
	align-items: center;

	background-color: ${(props) =>
		props.type === "primary" ? (props.isTarget ? "#DDE5EF" : "transparent") : props.isTarget ? "#DDE5EF" : "#ffffff"};
	border-radius: ${(props) => (props.type === "link" ? ".5rem" : "100rem")};
	border: ${(props) => (props.isTarget ? "2px solid #F6F9FC" : "none")};
	position: relative;

	& > img {
		cursor: pointer;
		transform-origin: center;
		transform: ${(props) => (props.collapsed ? "rotate(-90deg)" : "rotate(0deg)")};
		transition: all 0.3s ease-out;
	}

	& a,
	& .name {
		max-width: 100%;
		display: flex;
		align-items: center;
		column-gap: 1.2rem;

		& > span {
			height: min-content;
			max-width: calc(100% - 5.2rem);
			display: block;
			overflow: hidden;

			color: #0f0f0f;
			font-family: ${theme.font.secondary};
			font-size: 1.2rem;
			font-weight: 500;
		}
	}
	& .name {
		margin-left: 1rem;
	}

	& .details {
		position: absolute;
		right: 2rem;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		align-items: center;
		gap: 1rem;

		& span {
			padding: 0.5rem 1.2rem;
			margin-right: 1.8rem;
			font-size: 1.2rem;
			font-weight: 500;

			border-radius: 10rem;
			color: ${theme.color.blue3};
			background-color: ${theme.color.blue0};
		}
	}

	& div:not(.name):not(.details) {
		width: 5.4rem;
		height: 5.4rem;

		display: flex;
		align-items: center;
		justify-content: center;

		background-color: ${(props) => (props.color ? props.color : "cyan")};
		border-radius: 100rem;

		& > span {
			height: 1.7rem;
			width: min-content;

			color: #ffffff;
			text-transform: uppercase;
			font-family: ${theme.font.secondary};
			font-size: 2rem;
			font-weight: 500;

			display: block;
		}
	}

	& > span {
		height: min-content;
		margin-left: 1.2rem;

		font-family: ${theme.font.secondary};
		font-size: 1.2rem;
		font-weight: 500;
	}
`;
